const t = (o) => ({
  wrapper: {
    scrollMarginTop: 95,
    "@media(max-width: 600px)": {
      scrollMarginTop: 70
    }
  },
  title: {
    color: o.palette.common.blue400,
    fontSize: o.typography.fontSize32,
    lineHeight: 1.6
  },
  subtitle: {
    marginBottom: 45
  },
  accordionWrapper: {
    width: "100%",
    padding: 24,
    backgroundColor: o.palette.common.grey20,
    borderRadius: 40,
    "@media(max-width: 600px)": {
      padding: 16,
      paddingLeft: 0,
      paddingRight: 0
    }
  }
}), a = t;
export {
  a as default
};
